<div class="p-field">
  <label *ngIf="showLongLabel" for="poreski-broj" kodit-form-label
    >Jedinstveni broj korisnika javnih sredstava - JBKJS</label
  >
  <label *ngIf="showShortLabel" for="poreski-broj" kodit-form-label
    >JBKJS</label
  >
  <p-inputMask
    id="jbkjs"
    mask="99999"
    placeholder="Biće automatski popunjeno"
    [formControl]="control"
    [disabled]="disabled"
    [ngClass]="
      (control.dirty || control.touched) && !control.valid ? 'p-invalid' : ''
    "
    [styleClass]="
      (control.dirty || control.touched) && !control.valid ? 'p-invalid' : ''
    "
  ></p-inputMask>
  <kodit-error-info-required [formCtrl]="control"></kodit-error-info-required>
</div>
